'use client';

import { Accordion } from '@/components/molecules';
import { DistrictListSkeleton } from '@/components/organisms/skeletons/DistrictListSkeleton';
import { TeamLeaguesErrorPage } from '@/components/organisms/TeamLeaguesErrorPage';
import { useDistrictsInfoQuery } from '@/hooks/hooks';
import { useTeamLeagueStore } from '@/store/team-league-store';

interface DistrictListProps {
	teamLeagueId: string;
}

export const DistrictList = ({ teamLeagueId }: DistrictListProps) => {
	const { data: districtsInfo, isLoading, isError } = useDistrictsInfoQuery(teamLeagueId);
	const { labels } = useTeamLeagueStore();

	if (isLoading) {
		return <DistrictListSkeleton />;
	}

	if (isError || districtsInfo?.data?.teamLeagueDistricts.length == 0 || districtsInfo?.statusCode !== 200) {
		return (
			<TeamLeaguesErrorPage
				title="Unforced error!"
				description=" We just hit out of bounds...Please try back later."
				shouldTakeScreenWidth={false}
			/>
		);
	}

	return (
		<div className="my-6 flex w-full flex-col gap-8 xl:mx-0">
			<h2 className="text-2xl font-semibold leading-8 text-darkorange-600">{labels.districtPluralTitle}</h2>

			<div className="flex flex-col gap-6">
				{districtsInfo?.data?.teamLeagueDistricts.map((district) => (
					<Accordion
						key={district.uuid}
						districtName={district.title}
						numberOfDivisions={district.divisionsCount}
						districtImg={district?.logo?.url}
						divisions={district.divisions}
					/>
				))}
			</div>
		</div>
	);
};
